import axios from 'axios';
import apiService from '../apiService';
import getUserModelFromApiReturn from './getUserModelFromApiReturn';

export default async function loginUser(login = '', password = '') {
  try {
    const _ret = await axios({
      url: `${apiService.getUrl().faceRecognition}loginAdmin/login`,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        email: login,
        password: password
      }
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return getUserModelFromApiReturn(_ret.data);
  } catch (error) {
    console.log('Error getUserApi', error);
    throw error;
  }
}
